export default {
    USER_NOTIFICATION_SETTINGS: 'user-notification-settings',
}
